import _ from "lodash";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
import { CUSTOMER_SERVICE_URL } from "@/utils/constants/constants";
import { burypointEventCollect, burypointBehaviorInsertRecordFromSearchEngines } from "@/services/index";

import { ClientJS } from "clientjs";

/**
 * 判断数据是否为空
 * @param {*} value 数据
 * @returns boolean
 */
export function isValEmpty(value) {
  if (typeof value === "object" && value !== null) {
    // isEmpty 方法可以检查 value 是否为一个空对象、集合、映射或者 set。
    return _.isEmpty(value);
  } else {
    // isNil 方法可以检查一个值是否是 null 或者 undefined
    return _.isNil(value) || value === "";
  }
}

// 代理
export const PROXY_TYPE = {
  USER: "/proxyUser", //user代理
  API: "/proxyApi", //api代理
  OSS: "/proxyOss", //oss代理
  HOME: "/proxyHome", //2.0 代理
  TEM2: "/proxyTEM2",
  SEARCH: "/proxySearch"
};

// 清除cookies
export function clearCookies() {
  try {
    Cookies.remove(`${Cookies.get(CookieKeys.qlm_username)}${Cookies.get(CookieKeys.qlm_password)}`, "", {
      path: "/",
      domain: ".qianlima.com",
    });
  } catch (e) {
    console.error("clear Cookies error: ", e);
  }
  Cookies.remove(CookieKeys.qlm_username, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.qlm_password, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.xAuthToken, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.authToken, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userInfo, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userAppMenu, {
    path: "/",
    domain: ".qianlima.com",
  });
  Cookies.remove(CookieKeys.userLeftMenuClick, {
    path: "/",
    domain: ".qianlima.com",
  });
}

// 倒计时
export function timeCountdown(time, callback) {
  const timer = setInterval(() => {
    time--;
    callback(time);
    if (time === 0) {
      clearInterval(timer);
    }
  }, 1000);
}

const indexUrlOptions = {
  path: "/",
  domain: window.location.hostname,
};

// 设置cookie 参数可以是对象 设置一个值，参数是数组 设置多个值
export const setCookie = (data, days = 30) => {
  const exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  if (Array.isArray(data)) {
    for (const { key, val } of data) {
      Cookies.set(key, val, { ...indexUrlOptions, expires: days });
    }
  } else {
    const { key, val } = data;
    Cookies.set(key, val, { ...indexUrlOptions, expires: days });
  }
};

// 收否是移动端
export const isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

// 格式化手机号
export const phoneFormatter = (val) => {
  if (!val) return "";
  const sliceNum = val.length === 10 ? 6 : 7;
  return val.slice(0, 3) + "-" + val.slice(3, sliceNum) + "-" + val.slice(sliceNum);
};

// 回到顶部
export const scrollToTop = () => {
  scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

/**
 * 模版2 顶部按钮点击事件
 * @param typeMode 显示模式 0客服表单切换，1只显示咨询客服
 * @param callBack 回调函数
 */
export const topBtnOperation = (typeMode, callBack) => {
  if (typeMode === "0") {
    callBack.call();
  } else {
    window.open(
      CUSTOMER_SERVICE_URL,
      "",
      "height=499,width=712,top=300,left=300,toolbar=no,menubar=yes,scrollbars=yes,resizable=yes,location=no,status=no"
    );
  }
};

//生成唯一id 会话id
export const guid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

// 埋点通用方法
export const savePoint = (obj) => {
  let url = window.location.href;
  obj.url = url;
  let eventTime = new Date().getTime();
  obj.retainTime = eventTime - obj.eventTime;
  obj.eventTime = eventTime;
  let clickEvents = [];
  clickEvents.push(obj);
  return burypointEventCollect({ clickEvents });
}; 

export const setQlmVisitorId = () => {
  const referer =document.referrer;
  const list = [
    "baidu.com",
    "so.com",
    "360.com",
    "360.cn",
    "sogou.com",
    "toutiao.com",
    "sm.cn",
    "sohu.com",
    "bing.com",
    "163.com",
    "qq.com",
  ];
  let qlmVisitorId = Cookies.get(CookieKeys.qlmVisitorId);
  const client = new ClientJS();
  if (!referer) return;
  if (!checkStringContains(referer, list)) return;
  if (!qlmVisitorId) {
    // 设备指纹
    qlmVisitorId = client.getFingerprint();
    Cookies.set(CookieKeys.qlmVisitorId, qlmVisitorId, {
      expires: 365,
      domain: ".qianlima.com",
    });
  }

  try {
    burypointBehaviorInsertRecordFromSearchEngines({
      fingerId: qlmVisitorId,
      userAgent: client.getUserAgent(),
      referer,
      url: window.location.href,
      title: document.title || "没有标题",
      type: "SEM",
    });
  } catch (error) {
    console.error("设备埋点失败", error);
  }

  console.log("ClientJS---", qlmVisitorId);
};
function checkStringContains(string, array) {
  for (var i = 0; i < array.length; i++) {
    if (string.includes(array[i])) {
      return true;
    }
  }
  return false;
}

/**
 * 时间显示效果显示
 * @param {String} time 需要转换的时间
 * @param {String} option 格式 {y}-{m}-{d} {h}:{i}:{s}
 * @return: {String} 转换完成的时间
 */
export function conversionTime(time) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();
  if (d.toDateString() === new Date().toDateString()) {
    const diff = (now - d) / 1000;
    if (diff < 60) {
      return "1分钟前";
    } else if (diff < 3600) {
      // less 1 hour
      return Math.floor(diff / 60) + "分钟前";
    } else {
      return Math.floor(diff / 3600) + "小时前";
    }
  } else if (d < new Date()) {
    return getData(time);
  }
}


//时间戳转换年月日格式
export function getData(n) {
  let now = new Date(n),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
}